module.exports = __webpack_public_path__ + "img/img15.e4de91e4.png";